import { EditorState } from 'draft-js';
import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";



const WysiwygEditor = () => {
  // constructor(props) {
  //     super(props);
  //     this.state = {
  //         editorState: EditorState.createEmpty(),
  //     };
  //     }

  

  const [editorStateValue, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorStateValue) => {
    setEditorState(editorStateValue)
  };

  return (
    <div>
      <Editor
        editorState={editorStateValue}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={onEditorStateChange}
      />
      ;
    </div>
  );
};

export default WysiwygEditor;
